import { useEffect } from 'react';
import { usePortal } from '../../../hooks/useNavConfig';
import { useAppDispatch } from '../../../hooks';
import { setOnboardingProgress } from '../../../reducers/OnboardingProgress';
import { withErrorBoundary } from '../../../components/ErrorBoundary';
import { isHubspotOrigin } from './utils';
const isCorrectOnboardingProgressPayload = args => {
  return typeof args === 'object' && args !== null && 'progress' in args && 'selectedView' in args && 'groupKey' in args;
};
export const OnboardingProgressListener = ({
  isEnrolledInOnboarding
}) => {
  const dispatch = useAppDispatch();
  const {
    portalId
  } = usePortal();
  useEffect(() => {
    if (!isEnrolledInOnboarding || !portalId) {
      return;
    }
    const setupGuideUiListener = evt => {
      var _evt$data;
      if (isHubspotOrigin(evt.origin) && ((_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : _evt$data.type) === 'onboarding-progress' && isCorrectOnboardingProgressPayload(evt.data.payload)) {
        dispatch(setOnboardingProgress(evt.data.payload));
      }
    };
    window.addEventListener('message', setupGuideUiListener);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('message', setupGuideUiListener);
    };
  }, [dispatch, isEnrolledInOnboarding, portalId]);
  return null;
};
export default withErrorBoundary(OnboardingProgressListener, {
  boundaryName: 'OnboardingProgressListener'
});